var _style, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYolorektLogoHoles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 257.06 271.06",
    style: {
      enableBackground: "new 0 0 257.06 271.06"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fillRule:evenodd;clip-rule:evenodd;fill:#2A6DFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144.86,242.9c6.82,0,12.36-5.54,12.36-12.34c0-6.8-5.54-12.34-12.36-12.34c-6.83,0-12.37,5.54-12.37,12.34 C132.49,237.36,138.04,242.9,144.86,242.9z M144.86,194.06c20.16,0,36.57,16.37,36.57,36.5s-16.41,36.5-36.57,36.5 c-20.18,0-36.58-16.37-36.58-36.5S124.69,194.06,144.86,194.06z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.57,48.84c6.82,0,12.37-5.54,12.37-12.34c0-6.8-5.55-12.34-12.37-12.34S24.21,29.69,24.21,36.5 C24.21,43.3,29.75,48.84,36.57,48.84z M36.57,0c20.17,0,36.57,16.37,36.57,36.5c0,20.12-16.4,36.5-36.57,36.5 C16.41,72.99,0,56.62,0,36.5C0,16.37,16.41,0,36.57,0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M191.87,147.03c22.59,0,40.98-18.34,40.98-40.9c0-22.55-18.39-40.9-40.98-40.9c-22.59,0-40.98,18.34-40.98,40.9 C150.89,128.69,169.28,147.03,191.87,147.03z M191.87,41.08c35.95,0,65.19,29.19,65.19,65.06c0,35.87-29.24,65.05-65.19,65.05 c-35.95,0-65.19-29.18-65.19-65.05C126.68,70.27,155.92,41.08,191.87,41.08z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M206.22,254.75c0-9.01,7.32-16.32,16.35-16.32c9.03,0,16.35,7.31,16.35,16.32c0,9.01-7.32,16.31-16.35,16.31 C213.54,271.06,206.22,263.76,206.22,254.75"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.41,99.73c0-9.02,7.32-16.32,16.35-16.32c9.03,0,16.35,7.3,16.35,16.32c0,9.01-7.32,16.31-16.35,16.31 C82.73,116.05,75.41,108.74,75.41,99.73"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.6,225.32c0-8.9,7.22-16.11,16.13-16.11c8.92,0,16.14,7.21,16.14,16.11c0,8.89-7.22,16.1-16.14,16.1 C18.83,241.42,11.6,234.21,11.6,225.32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYolorektLogoHoles);
export default __webpack_public_path__ + "static/media/yolorekt_logo_holes.5195c43a8ee067bfd0e7cceca4d77ac6.svg";
export { ForwardRef as ReactComponent };